export default __webpack_public_path__ + "672b66653b33eeb6d3ccb72aacfb59d8.svg";